export default __webpack_public_path__ + "media/images/home/en/preview-5-53b6e99c24d0aad5800a8d0878e7b193.jpg";